import { Injectable, inject, Type } from '@angular/core';
import { Router } from '@angular/router';
import { MapNavigationHandler } from '@luzula/luzula-lib';
import { BohrpunktLegendeComponent } from './bohrpunkt-legende.component';

@Injectable({ providedIn: 'root' })
export class BohrpunktNavigationHandler implements MapNavigationHandler {
	private router = inject(Router);

	legendComponent: Type<any> = BohrpunktLegendeComponent;

	navigateToDetail(id: string): void {
		this.router.navigate(['/bohrpunkte', id]);
	}

	navigateToPrintView(ids: string[]): void {
		this.router.navigate(['/bohrpunkte/Drucken/multi'], {
			queryParams: { ids: ids.join(',') }
		});
	}

	getFilterHelpText(): string {
		return 'Bohrpunkttyp, Status, Kartierer, Datum';
	}
}
